import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ContentBox } from 'components/content-box';
import { DropZone, IframeNavBarView, Toc, UnsupportedFileDialog } from '../index';
import { BlockUi } from 'components/block-ui';
import { LoadingSpinner } from 'components/loading-spinner';
import { Button } from 'components/button/index';
import { integrationSelector } from 'common/selectors';
import { isIframe } from 'integration/integration.utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileVideo } from '@fortawesome/pro-duotone-svg-icons';
import { faFileAudio } from '@fortawesome/pro-duotone-svg-icons';

const podcastLabels = {
  upload: 'podcast_upload',
  choose: 'choose_a_podcast_to_upload',
  drag: 'or_drag_and_drop_a_podcast',
  formats: 'supported_podcast_formats',
};

const videoLabels = {
  upload: 'video_upload',
  choose: 'choose_a_video_to_upload',
  drag: 'or_drag_and_drop_a_video',
  formats: 'supported_video_formats',
};

export const SelectVideoView = connect((state) => ({
  integration: integrationSelector(state),
}))(({ integration, showBlockUi = false, onDrop, uploadButtonClickHandler, isValid = false, isPodcast = false }) => {
  const labels = isPodcast ? podcastLabels : videoLabels;
  const { t } = useTranslation();

  return (
    <div className="ct-select-video">
      <IframeNavBarView isIframe={isIframe(integration)} />
      <ContentBox className={isIframe(integration) ? 'iframe-reset-margin' : ''}>
        <h2 className="title">{t(labels.upload)}</h2>

        <DropZone onDrop={onDrop} enabled={isValid}>
          <div className="ct-select-video__justify-center" data-e2e="uploadDropZone">
            <Toc isValid={isValid} />
            <div className="ct-uploadIcon">
              <FontAwesomeIcon icon={isPodcast ? faFileAudio : faFileVideo} />
            </div>
            <input type="file" id="select-file-hidden-input" style={{ display: 'none' }} />
            <Button onClick={uploadButtonClickHandler} disabled={!isValid} displayWideInMobileSmall={true}>
              {t(labels.choose)}
            </Button>
          </div>
          <div className={`row justify-content-center ct-uploadText ${!isValid ? 'ct-uploadText--enabled' : ''}`}>
            {t(labels.drag)}
          </div>
        </DropZone>

        <div className="ct-uploadLegend">{t(labels.formats)}</div>

        <UnsupportedFileDialog />
        <BlockUi show={showBlockUi}>
          <LoadingSpinner />
        </BlockUi>
      </ContentBox>
    </div>
  );
});

SelectVideoView.propTypes = {
  showBlockUi: PropTypes.bool,
  onDrop: PropTypes.func.isRequired,
  uploadButtonClickHandler: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
  isPodcast: PropTypes.bool,
};
